import React from "react";
import { Link } from "react-router-dom";

export default function BillingCancelledPage() {
  return (
    <div className="page">
      <div className="card" style={{ maxWidth: 520, margin: "60px auto", textAlign: "center" }}>
        <h1 style={{ marginTop: 0 }}>Checkout cancelled</h1>
        <p className="muted">
          No worries — your account is unchanged. You can come back to
          this any time.
        </p>
        <div style={{ display: "flex", gap: 8, justifyContent: "center", marginTop: 16 }}>
          <Link to="/pricing" className="btn">See pricing</Link>
          <Link to="/" className="btn secondary">Back to dashboard</Link>
        </div>
      </div>
    </div>
  );
}
